import { KeyRound, UserCheck, UserX } from 'lucide-react';

import { Button } from '@/ui/primitives/button';
import { type UsuarioResumo } from '@fiscoai/contracts';

interface Props {
  usuario: UsuarioResumo;
  /** A própria linha: o server não deixa ninguém redefinir a própria senha por aqui. */
  propria: boolean;
  aoAlternar: (usuario: UsuarioResumo) => void;
  aoRedefinirSenha: (usuario: UsuarioResumo) => void;
}

/** Ações da linha em Pessoas (só para quem gerencia usuários). */
export function AcoesPessoa({ usuario, propria, aoAlternar, aoRedefinirSenha }: Props) {
  return (
    <span className="flex justify-end gap-0.5">
      {!propria && (
        <Button
          variante="fantasma"
          tamanho="icone-sm"
          aria-label={`Redefinir senha de ${usuario.nome}`}
          onClick={() => {
            aoRedefinirSenha(usuario);
          }}
        >
          <KeyRound aria-hidden />
        </Button>
      )}
      <Button
        variante="fantasma"
        tamanho="icone-sm"
        aria-label={usuario.ativo ? `Desativar ${usuario.nome}` : `Reativar ${usuario.nome}`}
        onClick={() => {
          aoAlternar(usuario);
        }}
      >
        {usuario.ativo ? <UserX aria-hidden /> : <UserCheck aria-hidden />}
      </Button>
    </span>
  );
}
